import React from 'react';
import {
  Box,
  Card,
  CardBody,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';

const TermsConditions: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box maxW="1400px" mx="auto" p={6}>
      <Card bg={bgColor} borderColor={borderColor}>
        <CardBody>
          <VStack spacing={4}>
            <Text fontSize="2xl" fontWeight="bold">
              Terms & Conditions
            </Text>
            <Text color="gray.600" textAlign="center">
              Review platform terms, conditions, and compliance requirements with versioning and tracking.
            </Text>
            <Text fontSize="sm" color="blue.600">
              Coming soon: Interactive terms and conditions with acknowledgment tracking
            </Text>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default TermsConditions; 